/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useState } from 'react';

import { compose } from 'recompose';

import { Tab, TabContext, TabPanel, Tabs } from '@coursera/cds-core';

import type {
  PickedLandingForTool,
  PropsFromAllPages,
} from 'bundles/coursera-plus-landing-page/contentful/fetchContentful';
import { withAllPagesData } from 'bundles/coursera-plus-landing-page/contentful/fetchContentful';
import ImageList from 'bundles/coursera-plus-landing-page/editorTool/ImageList';
import PretranslatedReferences from 'bundles/coursera-plus-landing-page/editorTool/PretranslatedReferences';
import {
  FeaturesContext,
  createFeaturesContextValue,
} from 'bundles/coursera-plus-landing-page/editorTool/contextHelper';

const styles = {
  container: () => css`
    padding: 32px;
  `,
};

type PropsToComponent = PropsFromAllPages;
type PropsToListComponent = {
  pages: PickedLandingForTool[];
};

const TABS = { translated: 'translated', images: 'images' };

const Features: React.FC<PropsToListComponent> = (props) => {
  const [selectedTab, setSelectedTab] = useState(TABS.translated);
  const handleTabChange = (newTab: string) => {
    setSelectedTab(newTab);
  };
  return (
    <FeaturesContext.Provider value={createFeaturesContextValue(props.pages)}>
      <TabContext value={selectedTab}>
        <Tabs onChange={handleTabChange}>
          <Tab label="References to translated" value={TABS.translated} />
          <Tab label="Image Assets" value={TABS.images} />
        </Tabs>

        <TabPanel value={TABS.translated}>
          <PretranslatedReferences />
        </TabPanel>
        <TabPanel value={TABS.images}>
          <ImageList />
        </TabPanel>
      </TabContext>
    </FeaturesContext.Provider>
  );
};

const EditorTool: React.FC<PropsToComponent> = (props) => {
  const { pages } = props;
  if (Array.isArray(pages)) {
    return (
      <div css={styles.container}>
        <Features pages={pages} />
      </div>
    );
  }
  return null;
};

export default compose<PropsToComponent, {}>(withAllPagesData())(EditorTool);
